<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
const props = defineProps({
    email: { type: String, required: true },
    label: { type: String, default: undefined },
    class: { type: String, default: undefined },
});

// COMPOSABLES
const { trackEmailLink } = useTracking();

// DATA
const mergedClass = twMerge('text-primary underline', props.class);
</script>

<template>
    <a :href="`mailto:${email}`" :class="mergedClass" @click="trackEmailLink(email)">
        <slot>{{ label ?? email }}</slot>
    </a>
</template>
